// extracted by extract-css-chunks-webpack-plugin
module.exports = {"swatches":"_2lsaV","active":"_3iFvJ","additional-swatches":"_3Gw4w"};